<template>
  <div class="preferences-nav" >
    <div v-if="showPopup" class="preferences-overlay" @click="toggleOpen"></div>
    <button class="open-preferences icon-heart-filled d-none d-lg-block" @click="showNav">
      <span>{{ $favorites.length }}</span>
    </button>


    <button @click="toPreferences" class="open-preferences icon-heart-filled d-block d-lg-none" >
      <span>{{ $favorites.length }}</span>
    </button>


    <div class="toggle-popup" :class="{ open: showPopup }"  >
      <div class="preferences-nav__list">
        <div class="preferences-nav__list--item"
             v-for="(favorite, i) in $favorites"
             :key="i"
             ref="likedhouse"
        >
          <img v-if="favorite.images && favorite.images.main" @click="showObject(favorite)" :src="favorite.images.main[0]" alt="Bouwnummer image">
          <span @click="showObject(favorite)" class="name">{{ objectTitle(favorite) }}</span>
          <span class="delete-item icon-delete" @click="dislike(i)"></span>

          <div class="item-overlay">
            <button @click="hideOverlay(i)"  class="btn btn-primary btn-white-40">Behouden</button>
            <button @click="$store.commit('removeFavorite', favorite.id), hideOverlay(i)" class="btn btn-red">Verwijderen</button>
          </div>

        </div>

        <div v-if="!$favorites.length">
          <p class="text-center">Je hebt nog geen favoriete woningen geselecteerd.</p>

        </div>


        <button @click="toPreferences" :disabled="!$favorites.length" class="btn btn-green">
          <span v-if="!$loggedIn">Voorkeuren definitief maken</span>
          <span v-if="$loggedIn">Wijzig voorkeuren</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>


  export default {

    data() {
      return {
        showPopup: false,
        parent:  this.$parent,
      }
    },

    methods: {
      objectTitle (object) {
        if(this.$store.state.apiData.building_title){
          let type = this.$store.state.apiData.building_title
          if(type === 'address'){
            return object.address.street + ' ' + object.address.number + object.address.number_suffix
          }
        }
        return 'Bouwnummer ' + object.build_number
      },
      toPreferences() {
        this.showPopup = false
        document.body.classList.remove('drop-down-open-pref')
        this.$router.push({ name: 'preferences' })
      },
      showNav () {
        this.showPopup = !this.showPopup
        document.body.classList.toggle('drop-down-open-pref')
        this.parent.checkOpenNav()
      },
      toggleOpen () {
        this.showPopup = false
        document.body.classList.remove('drop-down-open-pref')
      },
      showObject (object) {
        this.$router.push({
          name: 'detail',
          params: {
            object_id: object.id
          }
        })
        this.toggleOpen()
      },
        dislike(object){
            this.$el.querySelectorAll('.preferences-nav__list--item')[object].querySelector('.item-overlay').classList.add('active')
        },
        hideOverlay(object) {
            this.$el.querySelectorAll('.preferences-nav__list--item')[object].querySelector('.item-overlay').classList.remove('active')
        }
    },

  }
</script>

<style>
  .preferences-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .preferences-nav__list--item {
    cursor: pointer;
  }
</style>
